/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CompartmentPathQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CompartmentPathQueryOperator");
    }

    getFixupPrototypeFunction() { return CompartmentPathQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<CompartmentPathQueryOperator>): CompartmentPathQueryOperator {
        let obj = Object.assign(new CompartmentPathQueryOperator(), model);
        CompartmentPathQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CompartmentPathQueryOperator>): CompartmentPathQueryOperator {
        if (!model) return null;
        return CompartmentPathQueryOperator.newInstance(<CompartmentPathQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CompartmentPathQueryOperator) {
        if (!obj) return;

        models.CompartmentPathQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CompartmentPathQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CompartmentPathQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Compartment Paths to include
     */
    compartment_paths: Array<string>;

}
